import { useCallback, useMemo } from 'react'

import type { IMenuOption } from 'components/uiKit/Menu'
import type { Highlighted } from 'components/uiKit/Table/types'
import type { AnnounceSchemaFragment } from 'gql/__generated__/graphql'
import { getEnumOption } from 'utils/enum'

export enum AnnouncerTableActionUiEnum {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

export type AnnouncerTableActionHandlers = {
  onEdit: (announcer: AnnounceSchemaFragment) => void
  onDelete: (announcer: AnnounceSchemaFragment[]) => void
}

export const useTableActions = ({ onEdit, onDelete }: AnnouncerTableActionHandlers) => {
  const getActions = useCallback((selected: Highlighted<AnnounceSchemaFragment>[]) => {
    return [
      getEnumOption('AnnouncerTableActionUiEnum', AnnouncerTableActionUiEnum.EDIT, {
        hidden: selected.length !== 1,
      }),
      getEnumOption('AnnouncerTableActionUiEnum', AnnouncerTableActionUiEnum.DELETE, {
        hidden: selected.length === 0,
      }),
    ]
  }, [])

  const onClickMenuAction = useCallback(
    (
      option: IMenuOption<AnnouncerTableActionUiEnum>,
      selected: Highlighted<AnnounceSchemaFragment>[],
    ) => {
      switch (option.value) {
        case AnnouncerTableActionUiEnum.EDIT:
          if (selected.length === 1) {
            onEdit(selected[0])
          }
          break
        case AnnouncerTableActionUiEnum.DELETE:
          if (selected.length > 0) {
            onDelete(selected)
          }
          break
        default:
          break
      }
    },
    [onEdit, onDelete],
  )

  return useMemo(() => ({ getActions, onClickMenuAction }), [getActions, onClickMenuAction])
}
